<template>
  <div>
    <nav class="navbar is-black" role="navigation" aria-label="main navigation">
      <div class="navbar-burger" data-target="navMenu" @click="toggleMenu" :class="{'is-active': navIsActive}">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </div>

      <div class="navbar-menu" id="navMenu" :class="{'is-active': navIsActive}">
        <div class="navbar-start" @click="toggleMenu">
          <template v-for="item in startItems">
            <router-link :key="item.text" class="navbar-item" :to="{ name: item.link, params: { id: item.path } }">
              {{ item.text }}
            </router-link>
          </template>
        </div>
        <div class="navbar-end" @click="toggleMenu">
          <template v-for="item in endItems">
            <router-link :key="item.text" class="navbar-item" :to="{ name: item.link, params: { id: item.path } }">
              {{ item.text }}
            </router-link>
          </template>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { START_ITEMS, END_ITEMS, } from '@/helpers/nav_items';

export default {
  name: 'NavBar',
  data() {
    return {
      navIsActive: false,
      startItems: START_ITEMS,
      endItems: END_ITEMS,
    };
  },
  methods: {
    toggleMenu() {
      this.navIsActive = !this.navIsActive;
    },
  },
};
</script>

<style scoped>
</style>
